 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import SS_US_ADULT_SIGNUP_FRONT from '@/components/SS_US_adult_signup_front'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/Title'
 import CONTENTS from '@/components/Contents'
 import DEDICATION from '@/components/Dedication'
 import INTRODUCTION from '@/components/Introduction'
 import PART1 from '@/components/Part1'
 import CHAPTER1 from '@/components/Chapter1'
 import CHAPTER2 from '@/components/Chapter2'
 import CHAPTER3 from '@/components/Chapter3'
 import CHAPTER4 from '@/components/Chapter4'
 import PART2 from '@/components/Part2'
 import CHAPTER5 from '@/components/Chapter5'
 import CHAPTER6 from '@/components/Chapter6'
 import CHAPTER7 from '@/components/Chapter7'
 import PART3 from '@/components/Part3'
 import CHAPTER8 from '@/components/Chapter8'
 import CHAPTER9 from '@/components/Chapter9'
 import CHAPTER10 from '@/components/Chapter10'
 import CHAPTER11 from '@/components/Chapter11'
 import CHAPTER12 from '@/components/Chapter12'
 import CHAPTER13 from '@/components/Chapter13'
 import CHAPTER14 from '@/components/Chapter14'
 import CHAPTER15 from '@/components/Chapter15'
 import CHAPTER16 from '@/components/Chapter16'
 import CHAPTER17 from '@/components/Chapter17'
 import CONCLUSION from '@/components/Conclusion'
 import BIBLIOGRAPHY from '@/components/Bibliography'
 import AUTHOR from '@/components/Author'
 import ACKNOWLEDGMENTS from '@/components/Acknowledgments'
 import COPYRIGHT from '@/components/Copyright'
 import TABLES from '@/components/Tables'
 import LOVE_2 from '@/components/love_2'
 import SS_US_ADULT_SIGNUP_BACK from '@/components/SS_US_adult_signup_back'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Cover",
 			"name" : "Cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/SS_US_adult_signup_front",
 			"name" : "SS_US_adult_signup_front",
 			"component" : SS_US_ADULT_SIGNUP_FRONT
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Title",
 			"name" : "Title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Dedication",
 			"name" : "Dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/Introduction",
 			"name" : "Introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/Part1",
 			"name" : "Part1",
 			"component" : PART1
 		},
 		{
 			"path" : "/Chapter1",
 			"name" : "Chapter1",
 			"component" : CHAPTER1
 		},
 		{
 			"path" : "/Chapter2",
 			"name" : "Chapter2",
 			"component" : CHAPTER2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js